import { Component } from '@mycolorway/tao';
import baseMixin from './base';
import 'next/stylesheets/components/grid/cells/resize-cell.scss';

const HANDLE_TPL = `
<div class="grid-resize-layer">
  <div class="grid-resize-laser">
    <div class="laser-handle">
      <div class="laser-line"></div>
    </div>
  </div>
  <div class="grid-resize-handle"></div>
</div>
`;

class Store {
  constructor(key) {
    this.key = key;
  }

  load() {
    const raw = localStorage.getItem(this.key);
    try {
      return JSON.parse(raw) || {};
    } catch {
      return {};
    }
  }

  get(key) {
    return this.load()[key];
  }

  save(key, value) {
    const data = this.load();
    data[key] = value;
    const raw = JSON.stringify(data);
    localStorage.setItem(this.key, raw);
  }
}

Component('tr-grid-resize-cell', {
  mixins: [baseMixin],

  properties: {
    width: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 460,
    },
    min: {
      type: Number,
      default: 86,
    },
    syncKey: String,
  },

  connected() {
    this.store = new Store(`${window.location.pathname}:grid-resize-cell`);

    if (!this.width) {
      const style = window.getComputedStyle(this);
      this.width = parseFloat(style.width);
    }

    this.restore();
  },

  ready() {
    this.bodyHeight = document.body.getBoundingClientRect().height;

    this.style.width = `${this.width}px`;
    this.bindedMeasure = this.measure.bind(this);

    this.anchor = this.querySelector('.grid-resize-anchor');
    this.listenTo(this.anchor, 'mouseleave', this.hideHandle.bind(this));
    this.listenTo(this.anchor, 'mouseenter', this.showHandle.bind(this));
    this.listenTo(this.anchor, 'mousedown', this.startMeasure.bind(this));
    this.listenTo(document, 'mouseup', this.stopMeasure.bind(this));
  },

  hideHandle() {
    if (this.measuring) {
      return;
    }
    this.container.remove();
  },

  showHandle() {
    if (this.measuring) {
      return;
    }

    this.rect = this.getBoundingClientRect();
    this.anchorRect = this.anchor.getBoundingClientRect();

    this.container = document.createElement('div');
    this.container.classList.add('grid-resize-handle-container');
    this.container.innerHTML = HANDLE_TPL;
    this.container.querySelector('.grid-resize-layer').style.height = `${this.anchorRect.height}px`;

    this.handle = this.container.querySelector('.grid-resize-handle');
    this.laser = this.container.querySelector('.grid-resize-laser');
    this.laserLine = this.laser.querySelector('.laser-line');

    const left = this.anchorRect.left + 2;
    this.container.style.left = `${left}px`;
    this.container.style.top = `${this.anchorRect.top}px`;

    document.body.appendChild(this.container);
  },

  startMeasure(e) {
    this.measuring = true;

    const h = this.bodyHeight - this.anchorRect.height;
    this.handle.style.height = `${h}px`;
    this.laser.classList.add('held');
    this.laserLine.style.height = `${h}px`;

    this.width = this.rect.width;
    document.addEventListener('mousemove', this.bindedMeasure);

    e.preventDefault();
    e.stopPropagation();
  },

  measure(e) {
    if (!this.measuring) {
      return;
    }

    const delta = e.pageX - this.anchorRect.left - 2;
    const width = this.rect.width + delta;
    let over = false;

    if (width > this.max) {
      this.handle.classList.add('grid-resize-handle-max');
      this.handle.classList.remove('grid-resize-handle-min');
      over = true;
    } else if (width < this.min) {
      this.handle.classList.remove('grid-resize-handle-max');
      this.handle.classList.add('grid-resize-handle-min');
      over = true;
    } else {
      this.handle.classList.remove('grid-resize-handle-max');
      this.handle.classList.remove('grid-resize-handle-min');
    }

    this.handle.style.right = `${-delta}px`;
    if (!over) {
      this.width = width;
      this.laser.style.right = `${-delta}px`;
    }
  },

  stopMeasure() {
    if (!this.measuring) {
      return;
    }

    document.removeEventListener('mousemove', this.bindedMeasure);
    this.container.remove();

    this.style.width = `${this.width}px`;
    this.measuring = false;
    this.sync();
    this.snapshot();
  },

  sync() {
    this.namespacedTrigger('resized', {
      detail: { syncKey: this.syncKey, width: this.width },
      bubbles: true,
    });
  },

  snapshot() {
    this.store.save(this.syncKey, this.width);
  },

  restore() {
    const width = this.store.get(this.syncKey);
    if (width) {
      this.style.width = `${width}px`;
      this.width = width;
    }
    this.sync();
  },

  resize(width) {
    this.style.width = `${width}px`;
    this.width = width;

    this.sync();
  },
});
